// Wishlist Button Component
class WishlistButton extends HTMLElement {
  constructor() {
    super();
    this.handle = this.getAttribute('data-product-handle');
    this.button = this.querySelector('button');
    this.iconEmpty = this.querySelector('.icon-heart-empty');
    this.iconFilled = this.querySelector('.icon-heart-filled');
    
    this.button?.addEventListener('click', (e) => {
      e.preventDefault();
      this.toggleWishlist();
    });
    
    document.addEventListener('wishlist:updated', () => this.updateState());
    this.updateState();
  }
  
  getWishlistItems() {
    return JSON.parse(localStorage.getItem('theme_wishlist_items') || '[]');
  }
  
  updateState() {
    const items = this.getWishlistItems();
    const isInWishlist = items.includes(this.handle);
    
    if (isInWishlist) {
      if (this.iconEmpty) this.iconEmpty.style.display = 'none';
      if (this.iconFilled) this.iconFilled.style.display = 'block';
    } else {
      if (this.iconEmpty) this.iconEmpty.style.display = 'block';
      if (this.iconFilled) this.iconFilled.style.display = 'none';
    }
  }
  
  toggleWishlist() {
    let items = this.getWishlistItems();
    if (items.includes(this.handle)) {
      items = items.filter(i => i !== this.handle);
    } else {
      items.push(this.handle);
    }
    localStorage.setItem('theme_wishlist_items', JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('wishlist:updated'));
  }
}
if (!customElements.get('wishlist-button')) {
  customElements.define('wishlist-button', WishlistButton);
}

// Wishlist Drawer Component
class WishlistDrawerComponent extends HTMLElement {
  constructor() {
    super();
    this.dialog = this.querySelector('dialog');
    this.closeButton = this.querySelector('.close-button');
    this.itemsContainer = this.querySelector('.wishlist-drawer__items');
    
    this.closeButton?.addEventListener('click', () => this.close());
    
    // Close on overlay click
    this.dialog?.addEventListener('click', (e) => {
      if (e.target === this.dialog) this.close();
    });
    
    // Listen for custom open event
    document.addEventListener('wishlist:open', () => this.open());
    
    // Listen for wishlist updates
    document.addEventListener('wishlist:updated', () => {
      if (this.dialog && this.dialog.hasAttribute('open')) {
        this.renderItems();
      }
    });
    
    // Listen for remove events from inside the drawer
    document.addEventListener('wishlist:remove', (e) => {
      const handle = e.detail;
      let items = JSON.parse(localStorage.getItem('theme_wishlist_items') || '[]');
      items = items.filter(i => i !== handle);
      localStorage.setItem('theme_wishlist_items', JSON.stringify(items));
      document.dispatchEvent(new CustomEvent('wishlist:updated'));
    });
  }
  
  open() {
    if (this.dialog) {
      this.dialog.showModal();
      this.renderItems();
    }
  }
  
  close() {
    if (this.dialog) {
      this.dialog.close();
    }
  }
  
  getWishlistItems() {
    return JSON.parse(localStorage.getItem('theme_wishlist_items') || '[]');
  }
  
  async renderItems() {
    if (!this.itemsContainer) return;
    
    const handles = this.getWishlistItems();
    if (handles.length === 0) {
      this.itemsContainer.innerHTML = '<p style="padding: 2rem; text-align: center;">Your wishlist is empty.</p>';
      return;
    }
    
    this.itemsContainer.innerHTML = '<p style="padding: 2rem; text-align: center;">Loading...</p>';
    
    let html = '';
    for (const handle of handles) {
      try {
        const response = await fetch(`/products/${handle}.js`);
        if (!response.ok) continue;
        const product = await response.json();
        const price = (product.price / 100).toFixed(2);
        const image = product.featured_image || '//cdn.shopify.com/s/images/themes/product-1.png';
        
        html += `
          <div class="wishlist-item" style="display: flex; gap: 1.5rem; margin-bottom: 1.5rem; align-items: center; border-bottom: 1px solid rgba(var(--color-foreground-rgb), 0.1); padding-bottom: 1.5rem;">
            <a href="${product.url}" style="width: 80px; flex-shrink: 0; display: block; border-radius: var(--media-radius, 4px);">
              <img src="${image}" alt="${product.title}" style="width: 100%; height: auto; display: block; border-radius: inherit;" />
            </a>
            <div class="wishlist-item__details" style="flex-grow: 1;">
              <a href="${product.url}" class="h5" style="text-decoration: none; margin: 0 0 0.5rem 0; display: block;">${product.title}</a>
              <p style="margin: 0 0 1rem 0; opacity: 0.8;">$${price}</p>
              <button type="button" class="button button--secondary" style="padding: 0.5rem 1rem; min-height: unset; font-size: 0.85rem;" onclick="document.dispatchEvent(new CustomEvent('wishlist:remove', {detail: '${handle}'}))">Remove</button>
            </div>
          </div>
        `;
      } catch (err) {
        console.error('Failed to load wishlist item', err);
      }
    }
    
    this.itemsContainer.innerHTML = html;
  }
}
if (!customElements.get('wishlist-drawer-component')) {
  customElements.define('wishlist-drawer-component', WishlistDrawerComponent);
}
